// extracted by mini-css-extract-plugin
export default {"AppContainer":"App_AppContainer__iYDWl","container":"App_container__1o--E"};